import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch} from "react-redux";
import { pushNavigation } from "../../redux/slices/navigationSlice";
import BackButton from "../../components/backbutton";
import ScreenHeader from "../../components/ScreenHeader";
import Pagination from "../../components/Pagination";
import {
  LogOut,
  ShoppingCart,
  Package,
  Factory,
  Users,
  UserCheck,
  Briefcase,
  Store,
  FileText,
  Clock,
  Calendar,
  Eye,
  Check,
  X,
  Filter,
  Search,
} from "lucide-react";
import "./gmdashboard.css";

export default function DashboardGM({ user, onLogout }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("pending-po");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);
  
  const itemsPerPage = 5;
  const [currentPOPage, setCurrentPOPage] = useState(1);
  const [currentSchedulePage, setCurrentSchedulePage] = useState(1);
  const [currentProductionPlanPage, setCurrentProductionPlanPage] = useState(1);

  const resetPagination = () => {
    setCurrentPOPage(1);
    setCurrentSchedulePage(1);
    setCurrentProductionPlanPage(1);
  };

  const [pendingPOs, setPendingPOs] = useState([
    { id: "PO-001", poNumber: "PO-2024-001", vendor: "ABC Suppliers", date: "2024-03-15", amount: "₹1,25,000", quantity: 100, excess: 0, status: "Pending", department: "Purchase" },
    { id: "PO-002", poNumber: "PO-2024-002", vendor: "XYZ Enterprises", date: "2024-03-14", amount: "₹85,000", quantity: 50, excess: 5, status: "Pending", department: "Purchase" },
    { id: "PO-003", poNumber: "PO-2024-003", vendor: "Tech Solutions", date: "2024-03-13", amount: "₹2,50,000", quantity: 10, excess: 0, status: "Pending", department: "IT" },
    { id: "PO-004", poNumber: "PO-2024-004", vendor: "Global Metals", date: "2024-03-12", amount: "₹98,500", quantity: 75, excess: 3, status: "Pending", department: "Purchase" },
    { id: "PO-005", poNumber: "PO-2024-005", vendor: "Prime Plastics", date: "2024-03-11", amount: "₹42,000", quantity: 120, excess: 0, status: "Pending", department: "Production" },
    { id: "PO-006", poNumber: "PO-2024-006", vendor: "Elite Electronics", date: "2024-03-10", amount: "₹68,400", quantity: 60, excess: 2, status: "Pending", department: "Quality" },
    { id: "PO-007", poNumber: "PO-2024-007", vendor: "Apex Bearings", date: "2024-03-09", amount: "₹74,800", quantity: 160, excess: 0, status: "Approved", department: "Maintenance" }
  ]);

  const [schedules, setSchedules] = useState([
    { id: "SCH-001", customer: "ABC Corp", product: "Product A", quantity: 100, date: "2024-04-10", status: "Pending", priority: "High" },
    { id: "SCH-002", customer: "XYZ Ltd", product: "Product B", quantity: 50, date: "2024-04-12", status: "Pending", priority: "Medium" },
    { id: "SCH-003", customer: "PQR Industries", product: "Product C", quantity: 75, date: "2024-04-15", status: "Approved", priority: "Low" },
    { id: "SCH-004", customer: "LMN Corp", product: "Product D", quantity: 200, date: "2024-04-18", status: "Pending", priority: "High" },
    { id: "SCH-005", customer: "DEF Ltd", product: "Product E", quantity: 150, date: "2024-04-20", status: "Pending", priority: "Medium" },
    { id: "SCH-006", customer: "GHI Industries", product: "Product F", quantity: 90, date: "2024-04-22", status: "Approved", priority: "Low" }
  ]);

  const [productionPlans, setProductionPlans] = useState([
    { id: "PP-001", planNumber: "PP-2024-001", product: "Product A", quantity: 100, startDate: "2024-04-01", endDate: "2024-04-10", status: "Pending", priority: "High" },
    { id: "PP-002", planNumber: "PP-2024-002", product: "Product B", quantity: 50, startDate: "2024-04-05", endDate: "2024-04-15", status: "Pending", priority: "Medium" },
    { id: "PP-003", planNumber: "PP-2024-003", product: "Product C", quantity: 75, startDate: "2024-04-08", endDate: "2024-04-20", status: "Approved", priority: "Low" },
    { id: "PP-004", planNumber: "PP-2024-004", product: "Product D", quantity: 200, startDate: "2024-04-10", endDate: "2024-04-25", status: "Pending", priority: "High" },
    { id: "PP-005", planNumber: "PP-2024-005", product: "Product E", quantity: 150, startDate: "2024-04-12", endDate: "2024-04-28", status: "Pending", priority: "Medium" }
  ]);

  const departmentAccess = [
    { id: "sales", label: "Sales", icon: <ShoppingCart size={20} />, color: "#4F46E5", route: "/sales" },
    { id: "purchase", label: "Purchase", icon: <Package size={20} />, color: "#10B981", route: "/purchase" },
    { id: "production", label: "Production", icon: <Factory size={20} />, color: "#F59E0B", route: "/pmdashboard" },
    { id: "store", label: "Store", icon: <Store size={20} />, color: "#8B5CF6", route: "/store-dashboard" },
    { id: "supervisor", label: "Supervisor", icon: <UserCheck size={20} />, color: "#EF4444", route: "/supervisor-dashboard" },
    { id: "hr", label: "HR", icon: <Users size={20} />, color: "#EC4899", route: "/hr-dashboard" },
    { id: "employee", label: "Employee", icon: <Briefcase size={20} />, color: "#14B8A6", route: "/employee-dashboard" }
  ];

  const buttonStyles = {
    view: { backgroundColor: '#E0E7FF', color: '#4F46E5' },
    approve: { backgroundColor: '#D1FAE5', color: '#059669' },
    reject: { backgroundColor: '#FEE2E2', color: '#DC2626' },
    acceptOnly: { backgroundColor: '#FEF3C7', color: '#D97706' },
  };

  const ActionButton = ({ onClick, type, icon: Icon, tooltip }) => {
  const style = buttonStyles[type];
    return (
      <span style={{ position: 'relative', display: 'inline-block', verticalAlign: 'middle' }}>
        <button
          onClick={onClick}
          style={{
            width: '28px',
            height: '28px',
            padding: '0',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: style.backgroundColor,
            color: style.color,
            verticalAlign: 'middle',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = style.backgroundColor;
            e.currentTarget.style.color = style.color;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = style.backgroundColor;
            e.currentTarget.style.color = style.color;
          }}
        >
          <Icon size={14} />
        </button>
        <span className="tooltip-span">{tooltip}</span>
      </span>
    );
  };

  const tabItems = [
    { id: "pending-po", label: "Pending PO", icon: <FileText size={18} /> },
    { id: "list-schedule", label: "List Schedule", icon: <Calendar size={18} /> },
    { id: "list-production-plan", label: "List Production Plan", icon: <Clock size={18} /> }
  ];

  const handleLogoutClick = () => setShowLogoutModal(true);
  const handleConfirmLogout = () => { setShowLogoutModal(false); onLogout(); navigate('/login'); };
  const handleCancelLogout = () => setShowLogoutModal(false);

  const handleDepartmentClick = (department) => {
    dispatch(pushNavigation({ from: '/gmdashboard', to: department.route, fromName: 'GM Dashboard', toName: department.label }));
    navigate(department.route);
  };

  const handleApprovePO = (poId, acceptOnlyReq = false) => {
    const po = pendingPOs.find(p => p.id === poId);
    if (po && po.excess > 0 && !acceptOnlyReq) {
      const userChoice = window.confirm(`PO has excess quantity of ${po.excess}. Click OK to approve only required quantity, Cancel for full approval.`);
      if (userChoice) {
        alert(`PO ${poId} approved with only required quantity (${po.quantity}). Excess quantity rejected.`);
      } else {
        alert(`PO ${poId} approved with full quantity including excess.`);
      }
    } else {
      alert(`PO ${poId} has been approved!`);
    }
    setPendingPOs(pendingPOs.map(p => p.id === poId ? { ...p, status: "Approved" } : p));
  };

  const handleRejectPO = (poId) => {
    setPendingPOs(pendingPOs.filter(p => p.id !== poId));
    alert(`PO ${poId} has been rejected.`);
  };

  const handleApproveSchedule = (scheduleId) => {
    setSchedules(schedules.map(s => s.id === scheduleId ? { ...s, status: "Approved" } : s));
    alert(`Schedule ${scheduleId} has been approved!`);
  };

  const handleRejectSchedule = (scheduleId) => {
    setSchedules(schedules.filter(s => s.id !== scheduleId));
    alert(`Schedule ${scheduleId} has been rejected.`);
  };

  const handleApproveProductionPlan = (planId) => {
    setProductionPlans(productionPlans.map(p => p.id === planId ? { ...p, status: "Approved" } : p));
    alert(`Production Plan ${planId} has been approved!`);
  };

  const handleRejectProductionPlan = (planId) => {
    setProductionPlans(productionPlans.filter(p => p.id !== planId));
    alert(`Production Plan ${planId} has been rejected.`);
  };

  const filteredData = (data, searchFields) => {
    if (!searchTerm) return data;
    return data.filter(item => searchFields.some(field => item[field]?.toString().toLowerCase().includes(searchTerm.toLowerCase())));
  };

  const DepartmentAccessBar = () => (
    <div className="gm-department-bar">
      <div className="gm-department-scroll-container">
        <div className="gm-department-horizontal-grid">
          {departmentAccess.map((dept) => (
            <button key={dept.id} className="gm-department-card-horizontal" onClick={() => handleDepartmentClick(dept)} style={{ borderTopColor: dept.color }}>
              <div className="gm-dept-icon-horizontal" style={{ color: dept.color }}>{dept.icon}</div>
              <div className="gm-dept-label-horizontal">{dept.label}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  const PendingPOContent = () => {
    const filteredPOs = filteredData(pendingPOs, ['poNumber', 'vendor', 'department']);
    const totalPages = Math.ceil(filteredPOs.length / itemsPerPage);
    const currentPOs = filteredPOs.slice((currentPOPage - 1) * itemsPerPage, currentPOPage * itemsPerPage);

    return (
      <>
        <DepartmentAccessBar />
        <div className="gm-content-card">
          <div className="content-container">
            <div className="filter-bar">
              <Search size={18} />
              <input type="text" placeholder="Search PO..." className="search-input" value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); resetPagination(); }} />
              <button className="filter-btn" onClick={() => setFilterOpen(!filterOpen)}><Filter size={16} /> Filter</button>
            </div>
            {filterOpen && (
              <div className="filter-panel">
                <select className="filter-select"><option value="">All Departments</option><option>Purchase</option><option>IT</option><option>Production</option></select>
                <select className="filter-select"><option value="">All Status</option><option>Pending</option><option>Approved</option></select>
                <button className="apply-filter">Apply</button>
              </div>
            )}
            <div className="data-table-container">
              <div className="table-wrapper">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>PO Number</th>
                      <th>Vendor</th>
                      <th>Date</th>
                      <th>Quantity</th>
                      <th>Excess</th>
                      <th>Amount</th>
                      <th>Department</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPOs.map(po => (
                      <tr key={po.id}>
                        <td className="highlight">{po.poNumber}</td>
                        <td>{po.vendor}</td>
                        <td>{po.date}</td>
                        <td>{po.quantity}</td>
                        <td className={po.excess > 0 ? "amount excess" : ""}>{po.excess > 0 ? `+${po.excess}` : '0'}</td>
                        <td className="amount">{po.amount}</td>
                        <td>{po.department}</td>
                        <td><span className={`status ${po.status === 'Approved' ? 'approved' : 'pending'}`}>{po.status}</span></td>
                        <td>
                          <div className="action-buttons">
                            <ActionButton onClick={() => alert(`PO Details:\nVendor: ${po.vendor}\nQuantity: ${po.quantity}\nExcess: ${po.excess}\nAmount: ${po.amount}`)} type="view" icon={Eye} tooltip="View Details" />
                            {po.status === 'Pending' && (
                              <>
                                <ActionButton onClick={() => handleApprovePO(po.id, false)} type="approve" icon={Check} tooltip="Approve" />
                                {po.excess > 0 && (
                                  <ActionButton onClick={() => handleApprovePO(po.id, true)} type="acceptOnly" icon={Check} tooltip="Accept Only Required" />
                                )}
                                <ActionButton onClick={() => handleRejectPO(po.id)} type="reject" icon={X} tooltip="Reject" />
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Pagination currentPage={currentPOPage} totalPages={totalPages} onPageChange={setCurrentPOPage} pageSize={itemsPerPage} totalItems={filteredPOs.length} />
            </div>
          </div>
        </div>
      </>
    );
  };

  const ListScheduleContent = () => {
    const filteredSchedules = filteredData(schedules, ['id', 'customer', 'product']);
    const totalPages = Math.ceil(filteredSchedules.length / itemsPerPage);
    const currentSchedules = filteredSchedules.slice((currentSchedulePage - 1) * itemsPerPage, currentSchedulePage * itemsPerPage);

    return (
      <>
        <DepartmentAccessBar />
        <div className="gm-content-card">
          <div className="content-container">
            <div className="filter-bar">
              <Search size={18} />
              <input type="text" placeholder="Search schedules..." className="search-input" value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); resetPagination(); }} />
            </div>
            <div className="data-table-container">
              <div className="table-wrapper">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Schedule ID</th>
                      <th>Customer</th>
                      <th>Product</th>
                      <th>Quantity</th>
                      <th>Date</th>
                      <th>Priority</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentSchedules.map(sch => (
                      <tr key={sch.id}>
                        <td className="highlight">{sch.id}</td>
                        <td>{sch.customer}</td>
                        <td>{sch.product}</td>
                        <td>{sch.quantity}</td>
                        <td>{sch.date}</td>
                        <td><span className={`status ${sch.priority === 'High' ? 'pending' : 'approved'}`}>{sch.priority}</span></td>
                        <td><span className={`status ${sch.status === 'Approved' ? 'approved' : 'pending'}`}>{sch.status}</span></td>
                        <td>
                          <div className="action-buttons">
                            <ActionButton onClick={() => alert(`Schedule Details:\nCustomer: ${sch.customer}\nProduct: ${sch.product}\nQuantity: ${sch.quantity}`)} type="view" icon={Eye} tooltip="View Details" />
                            {sch.status === 'Pending' && (
                              <>
                                <ActionButton onClick={() => handleApproveSchedule(sch.id)} type="approve" icon={Check} tooltip="Approve" />
                                <ActionButton onClick={() => handleRejectSchedule(sch.id)} type="reject" icon={X} tooltip="Reject" />
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Pagination currentPage={currentSchedulePage} totalPages={totalPages} onPageChange={setCurrentSchedulePage} pageSize={itemsPerPage} totalItems={filteredSchedules.length} />
            </div>
          </div>
        </div>
      </>
    );
  };

  const ListProductionPlanContent = () => {
    const filteredPlans = filteredData(productionPlans, ['planNumber', 'product']);
    const totalPages = Math.ceil(filteredPlans.length / itemsPerPage);
    const currentPlans = filteredPlans.slice((currentProductionPlanPage - 1) * itemsPerPage, currentProductionPlanPage * itemsPerPage);

    return (
      <>
        <DepartmentAccessBar />
        <div className="gm-content-card">
          <div className="content-container">
            <div className="filter-bar">
              <Search size={18} />
              <input type="text" placeholder="Search production plans..." className="search-input" value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); resetPagination(); }} />
            </div>
            <div className="data-table-container">
              <div className="table-wrapper">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Plan #</th>
                      <th>Product</th>
                      <th>Quantity</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Priority</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentPlans.map(plan => (
                      <tr key={plan.id}>
                        <td className="highlight">{plan.planNumber}</td>
                        <td>{plan.product}</td>
                        <td>{plan.quantity}</td>
                        <td>{plan.startDate}</td>
                        <td>{plan.endDate}</td>
                        <td><span className={`status ${plan.priority === 'High' ? 'pending' : 'approved'}`}>{plan.priority}</span></td>
                        <td><span className={`status ${plan.status === 'Approved' ? 'approved' : 'pending'}`}>{plan.status}</span></td>
                        <td>
                          <div className="action-buttons">
                            <ActionButton onClick={() => alert(`Production Plan Details:\nProduct: ${plan.product}\nQuantity: ${plan.quantity}`)} type="view" icon={Eye} tooltip="View Details" />
                            {plan.status === 'Pending' && (
                              <>
                                <ActionButton onClick={() => handleApproveProductionPlan(plan.id)} type="approve" icon={Check} tooltip="Approve" />
                                <ActionButton onClick={() => handleRejectProductionPlan(plan.id)} type="reject" icon={X} tooltip="Reject" />
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Pagination currentPage={currentProductionPlanPage} totalPages={totalPages} onPageChange={setCurrentProductionPlanPage} pageSize={itemsPerPage} totalItems={filteredPlans.length} />
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderContent = () => {
    switch (activeTab) {
      case "pending-po": return <PendingPOContent />;
      case "list-schedule": return <ListScheduleContent />;
      case "list-production-plan": return <ListProductionPlanContent />;
      default: return <PendingPOContent />;
    }
  };

  return (
    <div className="gm-dashboard-container">
      {showLogoutModal && (
        <div className="logout-modal-overlay">
          <div className="logout-modal">
            <div className="logout-modal-header"><div className="logout-modal-icon">👋</div><h3>Confirm Logout</h3></div>
            <div className="logout-modal-body"><p>Are you sure you want to logout from <strong>General Manager</strong> dashboard?</p><p className="logout-modal-warning">You will be redirected to the login page.</p></div>
            <div className="logout-modal-footer">
              <button className="logout-modal-cancel" onClick={handleCancelLogout}>Cancel</button>
              <button className="logout-modal-confirm" onClick={handleConfirmLogout}>Yes, Logout</button>
            </div>
          </div>
        </div>
      )}

      <div className="gm-sidebar">
        <div className="gm-logo-container">
          <div className="gm-logo-icon"><img src="/rahulerp.jpg" alt="Company Logo" className="gm-logo-image" /></div>
          <div><h2 className="gm-company-name">Ragul Auto Tech</h2><p className="gm-company-tagline">AI Powered ERP</p></div>
        </div>
        <nav className="gm-nav-menu">
          {tabItems.map((tab) => (
            <button key={tab.id} className={`gm-nav-item ${activeTab === tab.id ? 'gm-nav-item-active' : ''}`} onClick={() => { setActiveTab(tab.id); resetPagination(); }}>
              <span className="gm-nav-icon">{tab.icon}</span><span>{tab.label}</span>
            </button>
          ))}
        </nav>
        <div className="gm-logout-container">
          <button onClick={handleLogoutClick} className="gm-logout-button"><LogOut size={18} /> Logout</button>
        </div>
      </div>

      <div className="gm-main-content">
        <ScreenHeader title="General Manager Dashboard" description={`Welcome, ${user?.role || 'General Manager'}`} timestamp={new Date().toLocaleString()} containerClassName="gm-header" titleClassName="gm-main-title" descriptionClassName="gm-subtitle" actionsClassName="gm-header-actions" timestampClassName="gm-last-updated" />
        <div className="gm-back-button-wrapper"><BackButton /></div>
        <div className="gm-scrollable-content">{renderContent()}</div>
      </div>
    </div>
  );
}